module.exports = __webpack_public_path__ + "img/item1.2dc49732.png";